














import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      pathes: [],
    };
  },
  mounted() {
    this.generatePath(this.$route);
  },
  watch: {
    $route(newPath) {
      this.generatePath(newPath);
    },
  },
  methods: {
    generatePath(newPath: any) {
      const matched = newPath.matched;
      let currentPath = "";

      this.pathes = matched.map((match: any) => {
        if (match.path === "") {
          return {
            path: "/dashboard",
            name: "トップ",
          };
        }
        currentPath += match.path;
        return {
          path: currentPath,
          name: match.name,
        };
      });
    },
  },
});
